import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('brandhub-back-top-button', wrap(Vue, () => import('~root/src/webcomponents/back-top-button/BackTopButton.vue?shadow')))

window.customElements.define('brandhub-background-animation', wrap(Vue, () => import('~root/src/webcomponents/background-animation/BackgroundAnimation.vue?shadow')))

window.customElements.define('brandhub-folding-gradient-background', wrap(Vue, () => import('~root/src/webcomponents/background-animation/FoldingGradientBackground.vue?shadow')))

window.customElements.define('brandhub-fullscreen-stage', wrap(Vue, () => import('~root/src/webcomponents/background-animation/FullscreenStage.vue?shadow')))

window.customElements.define('brandhub-bold-text', wrap(Vue, () => import('~root/src/webcomponents/bold-text/BoldText.vue?shadow')))

window.customElements.define('brandhub-icon', wrap(Vue, () => import('~root/src/webcomponents/brandhub-icon/Icon.vue?shadow')))

window.customElements.define('brandhub-brush-stage', wrap(Vue, () => import('~root/src/webcomponents/brush-stage/BrushStage.vue?shadow')))

window.customElements.define('brandhub-brush-stage-item', wrap(Vue, () => import('~root/src/webcomponents/brush-stage/BrushStageItem.vue?shadow')))

window.customElements.define('brandhub-co2-labeling', wrap(Vue, () => import('~root/src/webcomponents/co2-labeling/Co2Labeling.vue?shadow')))

window.customElements.define('brandhub-cross-fade', wrap(Vue, () => import('~root/src/webcomponents/cross-fade/CrossFade.vue?shadow')))

window.customElements.define('brandhub-cross-fade-item', wrap(Vue, () => import('~root/src/webcomponents/cross-fade/CrossFadeItem.vue?shadow')))

window.customElements.define('brandhub-cross-fade-slider', wrap(Vue, () => import('~root/src/webcomponents/cross-fade-slider/CrossFadeSlider.vue?shadow')))

window.customElements.define('brandhub-cross-fade-slider-item', wrap(Vue, () => import('~root/src/webcomponents/cross-fade-slider/CrossFadeSliderItem.vue?shadow')))

window.customElements.define('brandhub-disclaimer', wrap(Vue, () => import('~root/src/webcomponents/disclaimer/Disclaimer.vue?shadow')))

window.customElements.define('brandhub-editorial-highlight', wrap(Vue, () => import('~root/src/webcomponents/editorial-highlight/EditorialHighlight.vue?shadow')))

window.customElements.define('brandhub-expand-media', wrap(Vue, () => import('~root/src/webcomponents/expand-media/ExpandMedia.vue?shadow')))

window.customElements.define('brandhub-expanded-media', wrap(Vue, () => import('~root/src/webcomponents/expand-media/ExpandedMedia.vue?shadow')))

window.customElements.define('brandhub-f1-season', wrap(Vue, () => import('~root/src/webcomponents/f1-season/F1Season.vue?shadow')))

window.customElements.define('brandhub-footer-logo', wrap(Vue, () => import('~root/src/webcomponents/footer-logo/FooterLogo.vue?shadow')))

window.customElements.define('brandhub-footer-navigation', wrap(Vue, () => import('~root/src/webcomponents/footer-navigation/FooterNavigation.vue?shadow')))

window.customElements.define('brandhub-footer-navigation-item', wrap(Vue, () => import('~root/src/webcomponents/footer-navigation/FooterNavigationItem.vue?shadow')))

window.customElements.define('brandhub-footer-sections', wrap(Vue, () => import('~root/src/webcomponents/footer-sections/FooterSections.vue?shadow')))

window.customElements.define('brandhub-footer-sections-item', wrap(Vue, () => import('~root/src/webcomponents/footer-sections/FooterSectionsItem.vue?shadow')))

window.customElements.define('brandhub-sub-footer-sections-item', wrap(Vue, () => import('~root/src/webcomponents/footer-sections/SubFooterSectionsItem.vue?shadow')))

window.customElements.define('brandhub-footer-sitemap', wrap(Vue, () => import('~root/src/webcomponents/footer-sitemap/FooterSitemap.vue?shadow')))

window.customElements.define('brandhub-footer-sitemap-item', wrap(Vue, () => import('~root/src/webcomponents/footer-sitemap/FooterSitemapItem.vue?shadow')))

window.customElements.define('brandhub-footnotes', wrap(Vue, () => import('~root/src/webcomponents/footnotes/Footnotes.vue?shadow')))

window.customElements.define('brandhub-fullscreen-video', wrap(Vue, () => import('~root/src/webcomponents/fullscreenvideo/FullscreenVideo.vue?shadow')))

window.customElements.define('brandhub-flyout-button', wrap(Vue, () => import('~root/src/webcomponents/header/FlyoutButton.vue?shadow')))

window.customElements.define('brandhub-header', wrap(Vue, () => import('~root/src/webcomponents/header/Header.vue?shadow')))

window.customElements.define('brandhub-header-flyout-editor', wrap(Vue, () => import('~root/src/webcomponents/header/HeaderFlyoutEditor.vue?shadow')))

window.customElements.define('brandhub-header-flyout-image-item', wrap(Vue, () => import('~root/src/webcomponents/header/HeaderFlyoutImageItem.vue?shadow')))

window.customElements.define('brandhub-header-flyout-list-item', wrap(Vue, () => import('~root/src/webcomponents/header/HeaderFlyoutListItem.vue?shadow')))

window.customElements.define('brandhub-header-flyout-list-item-link', wrap(Vue, () => import('~root/src/webcomponents/header/HeaderFlyoutListItemLink.vue?shadow')))

window.customElements.define('brandhub-language-switcher', wrap(Vue, () => import('~root/src/webcomponents/header/LanguageSwitcher.vue?shadow')))

window.customElements.define('brandhub-language-switcher-item', wrap(Vue, () => import('~root/src/webcomponents/header/LanguageSwitcherItem.vue?shadow')))

window.customElements.define('brandhub-main-navigation', wrap(Vue, () => import('~root/src/webcomponents/header/MainNavigation.vue?shadow')))

window.customElements.define('brandhub-main-navigation-item', wrap(Vue, () => import('~root/src/webcomponents/header/MainNavigationItem.vue?shadow')))

window.customElements.define('brandhub-meta-navigation-flyout-link', wrap(Vue, () => import('~root/src/webcomponents/header/MetaNavigationFlyoutLink.vue?shadow')))

window.customElements.define('brandhub-sub-navigation-item', wrap(Vue, () => import('~root/src/webcomponents/header/SubNavigationItem.vue?shadow')))

window.customElements.define('brandhub-headline', wrap(Vue, () => import('~root/src/webcomponents/headline/Headline.vue?shadow')))

window.customElements.define('brandhub-headline-and-copy', wrap(Vue, () => import('~root/src/webcomponents/headline-and-copy/HeadlineAndCopy.vue?shadow')))

window.customElements.define('brandhub-hyperscreen', wrap(Vue, () => import('~root/src/webcomponents/hyperscreen/Hyperscreen.vue?shadow')))

window.customElements.define('brandhub-image-jumper', wrap(Vue, () => import('~root/src/webcomponents/image-jumper/ImageJumper.vue?shadow')))

window.customElements.define('brandhub-image-jumper-item', wrap(Vue, () => import('~root/src/webcomponents/image-jumper/ImageJumperItem.vue?shadow')))

window.customElements.define('brandhub-layered-gallery', wrap(Vue, () => import('~root/src/webcomponents/layered-gallery/LayeredGallery.vue?shadow')))

window.customElements.define('brandhub-layered-gallery-item', wrap(Vue, () => import('~root/src/webcomponents/layered-gallery/LayeredGalleryItem.vue?shadow')))

window.customElements.define('brandhub-media-gallery', wrap(Vue, () => import('~root/src/webcomponents/media-gallery/MediaGallery.vue?shadow')))

window.customElements.define('brandhub-media-gallery-item', wrap(Vue, () => import('~root/src/webcomponents/media-gallery/MediaGalleryItem.vue?shadow')))

window.customElements.define('brandhub-newsroom', wrap(Vue, () => import('~root/src/webcomponents/newsroom/Newsroom.vue?shadow')))

window.customElements.define('brandhub-paragraph-headline', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphHeadline.vue?shadow')))

window.customElements.define('brandhub-paragraph-image', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphImage.vue?shadow')))

window.customElements.define('brandhub-paragraph-labeling', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphLabeling.vue?shadow')))

window.customElements.define('brandhub-paragraph-linkout', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphLinkout.vue?shadow')))

window.customElements.define('brandhub-paragraph-text', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphText.vue?shadow')))

window.customElements.define('brandhub-paragraph-video', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphVideo.vue?shadow')))

window.customElements.define('brandhub-paragraph-wrapper', wrap(Vue, () => import('~root/src/webcomponents/paragraph/ParagraphWrapper.vue?shadow')))

window.customElements.define('brandhub-scroll-cross-fade', wrap(Vue, () => import('~root/src/webcomponents/scroll-cross-fade/ScrollCrossFade.vue?shadow')))

window.customElements.define('brandhub-scroll-text-fill', wrap(Vue, () => import('~root/src/webcomponents/scroll-text-fill/ScrollTextFill.vue?shadow')))

window.customElements.define('brandhub-scroll-word-fill', wrap(Vue, () => import('~root/src/webcomponents/scroll-text-fill/ScrollWordFill.vue?shadow')))

window.customElements.define('brandhub-social-media-box', wrap(Vue, () => import('~root/src/webcomponents/social-media-box/SocialMediaBox.vue?shadow')))

window.customElements.define('brandhub-social-media-box-item', wrap(Vue, () => import('~root/src/webcomponents/social-media-box/SocialMediaBoxItem.vue?shadow')))

window.customElements.define('brandhub-soft-configurator', wrap(Vue, () => import('~root/src/webcomponents/soft-configurator/SoftConfigurator.vue?shadow')))

window.customElements.define('brandhub-soft-configurator-exterior-item', wrap(Vue, () => import('~root/src/webcomponents/soft-configurator/SoftConfiguratorExteriorItem.vue?shadow')))

window.customElements.define('brandhub-soft-configurator-interior-item', wrap(Vue, () => import('~root/src/webcomponents/soft-configurator/SoftConfiguratorInteriorItem.vue?shadow')))

window.customElements.define('brandhub-stage', wrap(Vue, () => import('~root/src/webcomponents/stage/Stage.vue?shadow')))

window.customElements.define('brandhub-stage-item', wrap(Vue, () => import('~root/src/webcomponents/stage/StageItem.vue?shadow')))

window.customElements.define('brandhub-star-field-background', wrap(Vue, () => import('~root/src/webcomponents/star-field-background/StarFieldBackground.vue?shadow')))

window.customElements.define('brandhub-star-pattern', wrap(Vue, () => import('~root/src/webcomponents/star-pattern/StarPattern.vue?shadow')))

window.customElements.define('brandhub-teaser-tiles', wrap(Vue, () => import('~root/src/webcomponents/teaser-tiles/TeaserTiles.vue?shadow')))

window.customElements.define('brandhub-teaser-tiles-item', wrap(Vue, () => import('~root/src/webcomponents/teaser-tiles/TeaserTilesItem.vue?shadow')))

window.customElements.define('brandhub-text-mask', wrap(Vue, () => import('~root/src/webcomponents/text-mask/TextMask.vue?shadow')))

window.customElements.define('brandhub-vertical-gallery', wrap(Vue, () => import('~root/src/webcomponents/vertical-gallery/VerticalGallery.vue?shadow')))

window.customElements.define('brandhub-vertical-gallery-item', wrap(Vue, () => import('~root/src/webcomponents/vertical-gallery/VerticalGalleryItem.vue?shadow')))

window.customElements.define('brandhub-video-trailer', wrap(Vue, () => import('~root/src/webcomponents/video-trailer/VideoTrailer.vue?shadow')))

window.customElements.define('brandhub-video-trailer-item', wrap(Vue, () => import('~root/src/webcomponents/video-trailer/VideoTrailerItem.vue?shadow')))

window.customElements.define('brandhub-video-trailer-pager', wrap(Vue, () => import('~root/src/webcomponents/video-trailer/VideoTrailerPager.vue?shadow')))